import {
    NEWSLOADING,
    NEWSSUCCESS,
    NEWSERROR,
} from "../actionTypes";
import { news_url } from "../axios";


export const newssuccess =  data => {
    return {
        type: NEWSSUCCESS,
        payload: data
    }
}
export const newsloading =  data => {
    return {
        type: NEWSLOADING
    }
}

export const newserror = $ => {
    return {
        type: NEWSERROR
    }
}


export const fetchMarketNews = $ => async dispatch => {
      dispatch(newsloading())
      try{
             const data = await news_url.get();
             dispatch(newssuccess(data?.data?.articles))
      }
      catch(e){
          console.log('e:', e);

      }
}